import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { GraphListView } from 'scenes/patient/';
import CreatePatient from 'scenes/CreatePatient';
import AddGoal from 'whealth-core-web/components/AddGoal';
import QueueView from 'scenes/QueueView';
import IpdView from 'scenes/IpdView';
import IpdUserView from 'scenes/IpdUserView';

import UploadRport from 'whealth-core-web/components/UploadRport';
import {
  LoginScene,
  ArticleList,
  CreateArticles,
  Settings,
  Dashboard,
  Team,
  CreateTeam,
  Patient,
  ShowPatientProfile,
  ArticleView,
  Cockpit,
  Segment,
} from '../scenes';
import PrescriptionListView from 'scenes/patient/PrescriptionListView';
import AddQuestionForm from 'whealth-core-web/forms/AddQuestionForm';
import { Appointment, SegmentDefinitionForm } from 'whealth-core-web/components';
import { ZohoCallback } from 'whealth-core-web/components/ZohoCalendar/ZohoCallback';
import AddSummary from 'whealth-core-web/components/AddSummary';
import AddPrescription from 'components/AddPrescription';
import AddPaf from 'components/AddPaf';
import AddConsultation from 'whealth-core-web/components/patient/AddConsultation';
import AddDietPlan from 'whealth-core-web/components/patient/AddDietPlan';
import WebEngage from 'whealth-core-web/components/webEngage/WebEngage';
import Orders from 'whealth-core-web/components/Orders/Orders';
import AddTeleConsultation from 'whealth-core-web/components/patient/AddTeleConsultation';
import TeleconsultationDetail from 'whealth-core-web/components/patient/TeleconsultationDetail';
import JoinRoom from 'whealth-core-web/components/JoinRoom';
import AddQuestions from 'components/AddQuestions';
import AddConsultationProfile from 'scenes/AddConsultationProfile';
import AppointmentRecord from 'scenes/AppointmentRecord';
import AppointmentVer2 from 'whealth-core-web/components/AppointmentVer2/AppointmentVer2';
import OldAppointmentVer2 from 'whealth-core-web/components/AppointmentVer2/OldAppointmentVer2';
import AddService from 'whealth-core-web/AddService';
import SideBarReport from 'whealth-core-web/SideBarReport';
import PatientServiceTab from 'whealth-core-web/components/PatientService/PatientServiceTab';
import RedirectToWhatsApp from 'components/RedirectToWhatsApp';
import RefundPayment from 'whealth-core-web/components/RefundPayment/RefundPayment';

const AllRoutes = () => {
  const acessTokenLocal = localStorage.getItem('token');
  const { acessToken } = useSelector((state) => state.sliceReducer);

  if (acessToken || acessTokenLocal) {
    return (
      <Routes>
        <Route path='/' exact element={<Dashboard />} />
        <Route path='/dashboard' exact element={<Dashboard />} />
        <Route path='/zoho-callback' exact element={<ZohoCallback />} />
        <Route path='/articles' exact element={<ArticleList />} />
        <Route path='/cockpit' exact element={<Cockpit />} />
        <Route path='/segments' exact element={<Segment />} />
        <Route path='/segments/new' exact element={<SegmentDefinitionForm />} />
        <Route path='/segments/:id/edit' exact element={<SegmentDefinitionForm />} />
        <Route path='/articles/new' exact element={<CreateArticles />} />
        <Route path='/articles/:id/details/:title' exact element={<ArticleView />} />
        <Route path='/articles/:id/details/' exact element={<ArticleView />} />
        <Route path='/articles/:id/edit' exact element={<CreateArticles />} />
        <Route path='/home' exact element={<ArticleList />} />
        <Route path='/patient' exact element={<Patient />} />
        <Route path='/patient/:id/dashboard' exact element={<ShowPatientProfile isNivanCare={true} />} />
        <Route path='/patient/:id/goals/new' exact element={<AddGoal />} />
        <Route path='/patient/:id/goals/:goalid/edit' exact element={<AddGoal />} />
        <Route path='/patient/:id/reports/new' exact element={<UploadRport />} />
        <Route path='/patient/:id/reports/:reportid/edit' exact element={<UploadRport />} />
        <Route path='/patient/:id/prescriptions/new' exact element={<AddPrescription />} />
        <Route path='/patient/:id/paf/new' exact element={<AddPaf />} />
        <Route path='/patient/:id/paf/:pid' exact element={<AddPaf />} />
        <Route path='/patient/:id/service/new' exact element={<AddService />} />
        <Route path='/patient/:id/service/:pid/edit' exact element={<AddService />} />
        <Route path='/patient/:id/summaries/new' exact element={<AddSummary />} />
        <Route path='/patient/:id/summaries/:pid/edit' exact element={<AddSummary />} />
        <Route path='/patient/:id/questions/new' exact element={<AddQuestions />} />
        <Route path='/patient/:id/prescriptions/:pid/edit' exact element={<AddPrescription />} />
        <Route path='/patient/:id/teleconsultation/detail' exact element={<TeleconsultationDetail />} />
        <Route path='/patient/:id/questions/:pid/edit' exact element={<AddQuestions />} />
        <Route path='/patient/:id/dietPlan/new' exact element={<AddDietPlan />} />
        <Route path='/patient/:id/dietPlan/:pid/edit' exact element={<AddDietPlan />} />
        <Route path='/patient/:patientId/consultation' exact element={<AddConsultation isNivanCare={true} />} />
        <Route path='/patient/:patientId/appointment/:consultationId/edit' exact element={<AddConsultation isNivanCare={true} />} />
        <Route path='/patient/:id/teleconsultation/:teleId/joinRoom/:code' exact element={<JoinRoom />} />
        <Route path='/patient/:id/teleconsultation/new' exact element={<AddTeleConsultation />} />
        <Route path='/notifications' exact element={<WebEngage />} />
        <Route path='/reports' exact element={<SideBarReport />} />
        <Route path='/team' exact element={<Team />} />
        <Route path='/team/new' exact element={<CreateTeam />} />
        <Route path='/patient/new' exact element={<CreatePatient />} />
        <Route path='/patient/:id/edit' exact element={<CreatePatient />} />
        <Route path='/team/:id/edit' exact element={<CreateTeam />} />
        <Route path='/settings' exact element={<Settings />} />
        <Route path='/patient/:id/:pageTitle/:gid/show' exact element={<GraphListView />} />
        <Route path='//patient/:id/prescription/:pid/medicines/:mid/show' exact element={<PrescriptionListView />} />
        <Route path='/notifications' exact element={<WebEngage />} />
        <Route path='/orders' exact element={<Orders />} />
        <Route path='/appointment' exact element={<AppointmentVer2 isNivanCare={true} />} />
        <Route path='/old-appointment' exact element={<OldAppointmentVer2 isNivanCare={true} />} />
        <Route path='/refund-payments' exact element={<RefundPayment />} />
        <Route path='/appointment2' exact element={<AppointmentVer2 />} />
        <Route path='/patient/:patientId/appointment/new' exact element={<AddConsultation isNivanCare={true} />} />
        <Route path='/patient/:id/serviceDetails/new' exact element={<PatientServiceTab isNivanCare={true} />} />
        <Route path='/patient/:id/serviceDetails/:pid/edit' exact element={<PatientServiceTab isNivanCare={true} />} />
        <Route path='/patient/:patientId/appointment/:consultationId/view' exact element={<AddConsultation isNivanCare={true} />} />
        <Route path='/patient/:id/serviceDetails/:pid/view' exact element={<PatientServiceTab isNivanCare={true} />} />
        <Route path='/queue' exact element={<QueueView />} />
        <Route path='/send-message/:number' exact element={<RedirectToWhatsApp />} />
        <Route path='/ipd' exact element={<IpdView />} />
        <Route path='/ipdUser/:id' exact element={<IpdUserView />} />
      </Routes>
    );
  } else {
    return (
      <Routes>
        <Route path='/send-message/:number' exact element={<RedirectToWhatsApp />} />
        <Route path='/' exact element={<LoginScene />} />
        <Route path='/articles/:id/details/' exact element={<ArticleView />} />
        <Route path='/articles/:id/details/:title' exact element={<ArticleView />} />
      </Routes>
    );
  }
};

export default AllRoutes;
